// All prices sourced from groomingwithkate.com/pages/pricing (July 2026).
// Namespaced under window.GWK so it can't collide with theme JS.
window.GWK = window.GWK || {};

(function (GWK) {
  const DOG_WEIGHTS = [
    '0-15 lbs', '16-25 lbs', '26-40 lbs', '41-60 lbs', '61-80 lbs',
    '81-99 lbs', '100-120 lbs', '121-140 lbs', '141-160 lbs',
    '161-180 lbs', '181-199 lbs', '200-225 lbs', '226-249 lbs', '250+ lbs',
  ];

  const CAT_WEIGHTS = ['0-14 lbs', '15+ lbs'];

  // Each row: [standard, premium, platinum]
  GWK.PRICING = {
    'dog-short': {
      label: 'Short Hair Dog',
      examples: 'Pitbull, Boxer, Bulldog, Beagle, Great Dane',
      weights: DOG_WEIGHTS,
      rows: [
        [105, 116, 132], [111, 121, 137], [116, 126, 142], [126, 137, 153],
        [145, 147, 163], [147, 158, 174], [158, 168, 184], [179, 189, 205],
        [200, 210, 226], [221, 231, 247], [231, 242, 258], [242, 252, 268],
        [252, 263, 279], [263, 273, 289],
      ],
    },
    'dog-double': {
      label: 'Double Coat Short Hair Dog',
      examples: 'Labrador Retriever, Pug',
      weights: DOG_WEIGHTS,
      rows: [
        [105, 121, 137], [111, 126, 142], [121, 137, 153], [132, 147, 163],
        [142, 158, 174], [153, 168, 184], [168, 179, 189], [184, 195, 210],
        [205, 216, 231], [226, 237, 252], [237, 247, 263], [247, 258, 273],
        [258, 268, 284], [268, 279, 294],
      ],
    },
    'dog-long': {
      label: 'Long Hair Dog',
      examples: 'All Doodles, Rough Collie, Great Pyrenees, Yorkie, Shih Tzu, Golden Retriever',
      weights: DOG_WEIGHTS,
      rows: [
        [111, 126, 142], [121, 142, 163], [132, 147, 179], [137, 153, 184],
        [142, 158, 189], [158, 168, 205], [200, 210, 221], [210, 221, 231],
        [221, 231, 242], [231, 242, 252], [242, 252, 273], [252, 263, 284],
        [263, 273, 294], [284, 294, 315],
      ],
    },
    'cat-short': {
      label: 'Short Hair Cat',
      examples: '',
      weights: CAT_WEIGHTS,
      rows: [
        [150, 165, 180], [160, 175, 200],
      ],
    },
    'cat-long': {
      label: 'Long Hair Cat',
      examples: '',
      weights: CAT_WEIGHTS,
      rows: [
        [165, 185, 200], [180, 195, 220],
      ],
    },
  };

  GWK.PACKAGES = [
    {
      name: 'Standard',
      tagline: 'The essential spa bath',
      includes: [
        'Pre-rinse',
        'Premium shampoo',
        'Hydro-massage system',
        'Premium conditioner',
        '15-minute brush out',
      ],
    },
    {
      name: 'Premium',
      tagline: 'Everything in Standard, plus',
      includes: [
        'Nail trim',
        'Pad shaving',
        'Foot trimming',
      ],
    },
    {
      name: 'Platinum',
      tagline: 'Everything in Premium, plus',
      includes: [
        'Nail grinding',
        'Ear cleaning',
        'Teeth brushing',
        'Nose and paw balm',
        'Sanitary trim',
        'Bright white shampoo',
        'Cut and trim services',
      ],
    },
  ];

  GWK.ALA_CARTE = [
    ['Clip nails', 16],
    ['Grind nails', 21],
    ['Clean ears', 6],
    ['Brush teeth', 6],
    ['Nose and paw moisturizer', 4],
    ['Shave pads', 16],
    ['Sanitary trim', 11],
    ['Trim feet', 21],
    ['Face trim', 11],
  ];

  GWK.NAILS_ONLY_NOTE =
    'Nails-only house call: $53 for the first pet, then $16 per additional pet.';

  GWK.APPLICATION_URL =
    'https://form.moego.pet/go/form?formId=fa1bdfc56d4a4b5196eacc634b070941';

  GWK.FAQS = [
    ['How much does it cost?', 'The cost varies for every pet based on coat type, weight, and package. Use the price finder above to see exactly what your pet\'s groom will cost.'],
    ['Do you service anywhere besides Hartland?', 'Yes! We have a large service area around Hartland, Michigan. If you\'re outside our usual range, a small travel fee may apply — just ask.'],
    ['Will you stop just for nails?', 'Yes. A nails-only visit is $53 for the first pet, and $16 per pet after that for multi-pet households.'],
    ['Will you need my hose or an outlet?', 'No. Our buses are completely self-contained, with a generator for power and a 100-gallon tank of clean water.'],
    ['How often should my pet be groomed?', 'We usually recommend every 4 to 6 weeks. Regular grooming keeps your pet comfortable and healthy, especially breeds prone to tangling or shedding.'],
    ['Can I watch my pet get groomed?', 'We don\'t recommend it. We use sharp tools, and pets that move toward their owners on the table are at higher risk of an accidental cut. But you\'re always welcome to see the grooming unit itself!'],
    ['What happens if my dog is matted?', 'We assess the severity. Severe matting usually means a shave-down for your pet\'s comfort and safety, with additional charges applied.'],
    ['Does mobile cost more than a salon?', 'Yes. We\'re not a mobile version of a pet store. You\'re paying for experienced professional service, one-on-one attention, quality products, and patience.'],
    ['Is there a weight or size limit?', 'As long as your dog can fit through the door, we\'ll groom them.'],
    ['Do you have warm water?', 'Yes — water heaters on board, plus heat in the winter and air conditioning in the summer.'],
    ['How should I prepare my pet?', 'Please take your pet to go to the bathroom before we arrive. Aside from that, leave the rest to us!'],
    ['What payment do you accept?', 'Cash, debit cards, or credit cards.'],
  ];

  GWK.REVIEWS = [
    ['Theo has been going to Kate since he was 4 months old. She does an amazing job.', 'Lori C.'],
    ['What I love about Kate is her attention to detail and making sure the dog is comfortable.', 'Barb R.'],
    ['Zoé, our Bernedoodle puppy, had her first grooming session today, and she loved it!', 'CJ K.'],
    ['FINALLY! We found Kate, and Agnes does not freak out to get her hair done anymore!', 'Claire G.'],
    ['Kate worked with my baby, one on one, which I now realize is what he required all along.', 'Jenny H.'],
    ['She is so knowledgeable about her products and different dogs’ coats.', 'Jadyn S.'],
    ['Kate did an AMAZING job with my sweet goldendoodle. He just needed someone to be patient.', 'Joelle W.'],
    ['Rugby loves going to see Kate and runs straight to the door. We couldn’t be happier.', 'Annette M.'],
    ['Kate reassured me that she would be able to take the time to comb through it!', 'Madison G.'],
  ];

  GWK.TOWNS = [
    'Hartland', 'Fenton', 'Linden', 'Holly', 'Howell', 'Brighton',
    'Highland', 'White Lake', 'Milford', 'Green Oak', 'New Hudson',
    'Whitmore Lake',
  ];
})(window.GWK);
